import { Text, AtomBox, SwapCSS } from "@pancakeswap/uikit";

import { NumericalInput, NumericalInputProps } from "./NumericalInput";

// @ts-ignore
interface CurrencyInputPanelProps extends Omit<NumericalInputProps, "onBlur"> {
  onInputBlur?: () => void;
  id: string;
  top?: React.ReactNode;
  content?: React.ReactNode;
  bottom?: React.ReactNode;
  showBridgeWarning?: boolean;
}

export function CurrencyInputPanel({
  value,
  onUserInput,
  onInputBlur,
  top,
  content,
  bottom,
  id,
  disabled,
  error,
  loading,
  showBridgeWarning,
}: CurrencyInputPanelProps) {
  return (
    <AtomBox position="relative" id={id} display="grid">
      <div className={"flex flex-col gap-1 bg-gray-100 border border-solid border-gray-50 rounded-2xl p-4"}>
        <div className={"flex items-center justify-between"}>{top}</div>
        <div className={"flex"}>
          <AtomBox display="flex" alignItems="center" justifyContent="space-between">
            {content}
          </AtomBox>
          <NumericalInput
            error={Boolean(error)}
            disabled={disabled}
            loading={loading}
            className="token-amount-input"
            value={value}
            onBlur={onInputBlur}
            onUserInput={(val) => {
              onUserInput(val);
            }}
          />
        </div>
        {bottom}
      </div>

      {error ? (
        <Text pb="8px" fontSize="12px" color="red">
          {error}
        </Text>
      ) : null}

      {disabled && (
        <AtomBox role="presentation" position="absolute" inset="0px" backgroundColor="backgroundAlt" opacity="0.6" />
      )}
    </AtomBox>
  );
}
